module.exports = __webpack_public_path__ + "static/jetblue-10e7316e8340d7372878ec0ea82c9f87.png";